var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from 'vue-property-decorator';
// date libs
import * as isToday from 'date-fns/is_today';
import * as format from 'date-fns/format';
// dependency-injection
import { TYPES } from '@/dependency-injection/types';
import { lazyInject } from '@/dependency-injection';
import { ReferenceDataService } from '@/services/reference-data-service';
import OpportunityTable from '@/pages/opportunity-management/shared/OpportunityTable.vue';
var OpportunityTableMixin = /** @class */ (function (_super) {
    __extends(OpportunityTableMixin, _super);
    function OpportunityTableMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionDialogVisible = false;
        _this.action = '';
        _this.loadId = '';
        return _this;
    }
    OpportunityTableMixin.prototype.openActionDialog = function (loadId, action) {
        this.actionDialogVisible = true;
        this.action = action;
        this.loadId = loadId;
    };
    OpportunityTableMixin.prototype.closeActionDialog = function () {
        this.actionDialogVisible = false;
    };
    Object.defineProperty(OpportunityTableMixin.prototype, "isDateToday", {
        /**
         * Get if the date provided is today
         */
        get: function () {
            return isToday(this.date);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityTableMixin.prototype, "formattedDate", {
        /**
         * Get formatted date for display
         */
        get: function () {
            return format(this.date, 'MM/DD/YYYY');
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        lazyInject(TYPES.ReferenceDataService),
        __metadata("design:type", typeof (_a = typeof ReferenceDataService !== "undefined" && ReferenceDataService) === "function" ? _a : Object)
    ], OpportunityTableMixin.prototype, "referenceDataService", void 0);
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], OpportunityTableMixin.prototype, "siteId", void 0);
    __decorate([
        Prop({ type: [Date, String], required: true }),
        __metadata("design:type", Object)
    ], OpportunityTableMixin.prototype, "date", void 0);
    OpportunityTableMixin = __decorate([
        Component({
            components: {
                'opportunity-table': OpportunityTable,
            },
        })
    ], OpportunityTableMixin);
    return OpportunityTableMixin;
}(Vue));
export default OpportunityTableMixin;
